.root {
  flex: 1; /* fill height if inside flex container in consumer app */
  display: flex;
  min-width: 0;
  min-height: 0;
  margin: 0;
  --curve-color: var(--h5w-line--color, darkblue);
  --aux-colors: var(
    --h5w-line--colorAux,
    orangered,
    forestgreen,
    red,
    mediumorchid,
    olive
  );
}

.tooltipItem {
  display: flex;
  align-items: baseline;
}

.tooltipValue,
.tooltipAux {
  composes: tooltipItem;
}

.tooltipValue[data-hidden] {
  opacity: 0.3;
}

.tooltipValue,
.tooltipValue + .tooltipAux {
  margin-top: 0.25rem;
}

.tooltipValue strong {
  font-weight: 600;
  font-size: 1.125em;
}

.mark {
  content: '';
  display: block;
  width: 0.75em;
  height: 0.375rem;
  margin-right: 0.375rem;
  padding-bottom: 0.125rem;
  background-color: currentColor;
  transform: translateY(-1px);
}
